import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle2, PlayCircle } from 'lucide-react';
import { activityMeta, activityLaunchPath } from '../../lib/activityTypes';

// "Continue where you left off" — opens the learner's next unlocked, incomplete activity.
export default function ResumeCard({ programmeId, activity, started, onLaunch, compact = false }) {
  const navigate = useNavigate();
  if (!activity) {
    return (
      <div className="rounded-xl border border-teal-500/30 bg-teal-500/10 px-4 py-3 text-sm text-teal-200 flex items-center gap-2" data-testid={`resume-caught-up-${programmeId}`}>
        <CheckCircle2 className="h-4 w-4 shrink-0" />All caught up — nothing new to start right now.
      </div>
    );
  }
  const meta = activityMeta(activity);
  const Icon = meta.icon;
  const open = () => {
    if (onLaunch) return onLaunch(activity);
    const path = activityLaunchPath(activity, programmeId);
    return navigate(path || `/programmes/${programmeId}`);
  };
  return (
    <div className={`rounded-xl border border-zinc-700/80 bg-zinc-950/60 flex flex-wrap items-center gap-3 ${compact ? 'p-3' : 'p-4'}`} data-testid={`resume-card-${programmeId}`}>
      <span className={`${compact ? 'h-9 w-9' : 'h-11 w-11'} shrink-0 rounded-lg flex items-center justify-center`} style={{ backgroundColor: `${meta.color}1f`, color: meta.color }}>
        <Icon className={compact ? 'h-4 w-4' : 'h-5 w-5'} />
      </span>
      <div className="flex-1 min-w-[160px]">
        <p className="text-[11px] uppercase tracking-[0.15em] text-zinc-500">{started ? 'Continue where you left off' : 'Start your programme'}</p>
        <p className="text-white font-medium truncate" data-testid={`resume-title-${programmeId}`}>{activity.title}</p>
        {activity.period_title && <p className="text-xs text-zinc-500 truncate">{activity.period_title} · {meta.label}</p>}
      </div>
      <button type="button" onClick={open}
        className="group flex items-center gap-2 px-4 py-2 rounded-full bg-teal-600 hover:bg-teal-500 text-white text-sm font-medium transition-colors"
        data-testid={`resume-btn-${programmeId}`}>
        {started ? 'Continue' : 'Start'}
        {started ? <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /> : <PlayCircle className="h-4 w-4" />}
      </button>
    </div>
  );
}
